var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"empty_box"},[_c('div',{staticClass:"detail-item__value",class:{isLink: _vm.isLink},on:{"click":_vm.handleLink}},[_vm._v(" "+_vm._s(_vm.text)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }